import initialState from '../core/initialState';
import Event from '../core/Event';
import UserEstimation from '../../domain/UserEstimation';
import UserEstimationsGetSucceed from './events/UserEstimationsGetSucceed';

export default (state: UserEstimation[] = initialState.userEstimations, anyEvent: Event): UserEstimation[] => {
    switch (anyEvent.type) {
        case UserEstimationsGetSucceed.type:
            return (anyEvent as UserEstimationsGetSucceed).estimations;
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/application/estimations/reducer.ts